import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api, getToken, setToken, authed } from './api';

const DistributorAuthContext = createContext(null);
const AdminAuthContext = createContext(null);
const SuperAdminAuthContext = createContext(null);

export function DistributorAuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        if (!getToken('distributor')) { setUser(null); setLoading(false); return; }
        try {
            const r = await authed('distributor', { method: 'GET', url: '/dist/auth/me' });
            setUser(r.data);
        } catch (e) {
            setToken('distributor', null);
            setUser(null);
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    const signIn = (token, user) => { setToken('distributor', token); setUser(user); };
    const signOut = () => { setToken('distributor', null); setUser(null); };

    return (
        <DistributorAuthContext.Provider value={{ user, loading, refresh, signIn, signOut }}>
            {children}
        </DistributorAuthContext.Provider>
    );
}
export const useDistributor = () => useContext(DistributorAuthContext);

export function AdminAuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const t = getToken('admin');
        if (!t) { setLoading(false); return; }
        try {
            const payload = JSON.parse(atob(t.split('.')[1]));
            if (payload.exp && payload.exp * 1000 > Date.now()) {
                setAdmin({ id: payload.sub, email: payload.email, display_name: payload.display_name });
            } else {
                setToken('admin', null);
            }
        } catch { setToken('admin', null); }
        setLoading(false);
    }, []);

    const signIn = (token, adminObj) => { setToken('admin', token); setAdmin(adminObj); };
    const signOut = () => { setToken('admin', null); setAdmin(null); };
    return (
        <AdminAuthContext.Provider value={{ admin, loading, signIn, signOut }}>{children}</AdminAuthContext.Provider>
    );
}
export const useAdmin = () => useContext(AdminAuthContext);

export function SuperAdminAuthProvider({ children }) {
    const [sa, setSa] = useState(null);
    const [loading, setLoading] = useState(true);
    useEffect(() => {
        const t = getToken('super_admin');
        if (!t) { setLoading(false); return; }
        try {
            const payload = JSON.parse(atob(t.split('.')[1]));
            if (payload.exp && payload.exp * 1000 > Date.now()) {
                setSa({ id: payload.sub, email: payload.email, display_name: payload.display_name });
            } else {
                setToken('super_admin', null);
            }
        } catch { setToken('super_admin', null); }
        setLoading(false);
    }, []);
    const signIn = (token, saObj) => { setToken('super_admin', token); setSa(saObj); };
    const signOut = () => { setToken('super_admin', null); setSa(null); };
    return (
        <SuperAdminAuthContext.Provider value={{ superAdmin: sa, loading, signIn, signOut }}>{children}</SuperAdminAuthContext.Provider>
    );
}
export const useSuperAdmin = () => useContext(SuperAdminAuthContext);
